/**
 *
 * Lib Noob Module... uh... Noop Module
 *
 */
Lib.Noop = {
    true: function() {
        return true;
    },
    false: function() {
        return false;
    },
    undefined: function() {
    },
    null: function() {
        return null;
    }
};